import { render, staticRenderFns } from "./EMentoringServiceArea.vue?vue&type=template&id=b3aa4016"
import script from "./EMentoringServiceArea.vue?vue&type=script&lang=ts"
export * from "./EMentoringServiceArea.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports